const safeLocalStorage = {
  getItem: key => {
    try {
      return localStorage.getItem(key);
    } catch (err) {
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      localStorage.setItem(key, value);
      // eslint-disable-next-line no-empty
    } catch (err) {}
  },
  removeItem(key) {
    try {
      localStorage.removeItem(key);
      // eslint-disable-next-line no-empty
    } catch (err) {}
  }
};
export default safeLocalStorage;